import { IAllProps } from '@tinymce/tinymce-react';
import { TINY_MCE_INVALID_ELEMENTS, validChildren } from 'modules/wysiwygEditor/constants';
import { useTheme } from 'styled-components';
import { FONT_STYLES, TOKEN_HTML_TAG } from '../constants';
import { useEditorContext } from '../contexts/editor';
import { useBodyStyles } from './useBodyStyles';
import { useTokenStyles } from './useTokenStyles';

export const useInitialEditorConfig = (): IAllProps['init'] => {
  const { setEditor } = useEditorContext();
  const theme = useTheme();
  const bodyStyles = useBodyStyles();
  const tokenStyles = useTokenStyles();

  return {
    // TinyMCE config
    setup: setEditor,
    paste_tab_spaces: 2,
    content_style: `
      ${FONT_STYLES}
      ${bodyStyles}
      ${tokenStyles}
    `,
    height: theme.spacing.values.x10,
    highlight_on_focus: false, // controls blue focus outline
    auto_focus: true,
    iframe_attrs: {
      style: 'background-color: transparent;',
    },

    // Disable extra features
    branding: false,
    statusbar: false,
    menubar: false,
    toolbar: false,

    // Security
    invalid_elements: TINY_MCE_INVALID_ELEMENTS,
    valid_children: [
      validChildren,
      `+p[${TOKEN_HTML_TAG}]`,
      `-a[${TOKEN_HTML_TAG}]`,
      `-em[${TOKEN_HTML_TAG}]`,
      `-strong[${TOKEN_HTML_TAG}]`,
      `-span[${TOKEN_HTML_TAG}]`,
      `${TOKEN_HTML_TAG}[img]`,
    ].join(','),
    custom_elements: `~${TOKEN_HTML_TAG}`,
  };
};
